import React, { useState } from 'react';
import { User, FileText, Briefcase, FileCheck, Wrench, BarChart2, MapPin, Settings, Home } from 'lucide-react';
import CustomerManagement from './CustomerManagement';
import ServicesManagement from './ServicesManagement';
import EstimationSystem from './EstimationSystem';
import JobsManagement from './JobsManagement';
import InvoiceManagement from './InvoiceManagement';
import ReportsMenu from './ReportsMenu';
import { Preferences } from './Preferences';
import PropertiesManagement from './PropertiesManagement';
import BusinessDashboard from './BusinessDashboard';


function App() {
  const [activePage, setActivePage] = useState('dashboard');
  const [conversionData, setConversionData] = useState(null);

  const navTiles = [
    { id: 'home', title: 'HOME', icon: Home, color: 'bg-blue-500' },
    { id: 'customers', title: 'CUSTOMERS', icon: User, color: 'bg-blue-500' },
    { id: 'estimating', title: 'ESTIMATING', icon: FileText, color: 'bg-green-500' },
    { id: 'jobs', title: 'JOBS', icon: Briefcase, color: 'bg-pink-500' },
    { id: 'invoicing', title: 'INVOICING', icon: FileCheck, color: 'bg-yellow-500' },
    { id: 'services', title: 'SERVICES', icon: Wrench, color: 'bg-pink-500' },
    { id: 'reporting', title: 'REPORTING', icon: BarChart2, color: 'bg-gray-700' },
    { id: 'properties', title: 'PROPERTIES', icon: MapPin, color: 'bg-orange-500' },
    { id: 'preferences', title: 'PREFERENCES', icon: Settings, color: 'bg-gray-600' }
  ];

  // Home Dashboard
  if (activePage === 'home') {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b">
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <img src="/jft-logo.png" alt="JFT Contracting" className="h-8 w-auto" />
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
                onClick={() => setActivePage('dashboard')}
              >
                ← BACK TO NAVIGATION
              </button>
            </div>
          </div>
        </div>
        <div className="px-6 py-8">
          <BusinessDashboard />
        </div>
      </div>
    );
  }

  // Return Customer Management if customers page is active
  if (activePage === 'customers') {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b">
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <img src="/jft-logo.png" alt="JFT Contracting" className="h-8 w-auto" />
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
                onClick={() => setActivePage('dashboard')}
              >
                ← BACK TO NAVIGATION
              </button>
            </div>
          </div>
        </div>
        <div className="px-6 py-8">
          <CustomerManagement />
        </div>
      </div>
    );
  }

  if (activePage === 'dashboard') {
    return (
      <div className="min-h-screen bg-gray-100">
        {/* Header */}
        <div className="bg-white shadow-sm border-b">
        <div className="px-6 py-8">
          <div className="text-center">
            <div className="flex justify-center mb-4">
              <img
                src="/jft-logo.png"
                alt="JFT Contracting"
                className="h-20 w-auto"
              />
            </div>
            <div className="w-32 h-1 bg-red-800 mx-auto mb-4"></div>
            <h2 className="text-2xl font-semibold text-gray-600 tracking-wide">
              BUSINESS MANAGEMENT SYSTEM
            </h2>
          </div>
        </div>
      </div>

        {/* Navigation Grid */}
        <div className="px-6 py-12">
          <div className="grid grid-cols-3 gap-6 max-w-5xl mx-auto">
            {navTiles.map(tile => {
              const IconComponent = tile.icon;
              return (
                <div
                  key={tile.id}
                  className={`${tile.color} text-white rounded-lg shadow-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 cursor-pointer group`}
                  onClick={() => setActivePage(tile.id)}
                >
                  <div className="h-32 flex flex-col items-center justify-center p-6">
                    <div className="mb-3 group-hover:scale-110 transition-transform duration-300">
                      <IconComponent size={40} strokeWidth={1.5} />
                    </div>
                    <div className="text-center font-bold text-base tracking-wide leading-tight">
                      {tile.title}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
  if (activePage === 'services') {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b">
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <h1 className="text-2xl font-bold text-red-800">JFT WORKS</h1>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
                onClick={() => setActivePage('dashboard')}
              >
                ← BACK TO NAVIGATION
              </button>
            </div>
          </div>
        </div>
        <div className="px-6 py-8">
          <ServicesManagement />
        </div>
      </div>
    );
  }
  if (activePage === 'estimating') {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b">
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <img src="/jft-logo.png" alt="JFT Contracting" className="h-8 w-auto" />
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
                onClick={() => setActivePage('dashboard')}
              >
                ← BACK TO NAVIGATION
              </button>
            </div>
          </div>
        </div>
        <div className="px-6 py-8">
          <EstimationSystem
            onConvertToJob={(estimateData) => {
              setConversionData(estimateData);
              setActivePage('jobs');
            }}
          />
        </div>
      </div>
    );
  }
  if (activePage === 'jobs') {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b">
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <img src="/jft-logo.png" alt="JFT Contracting" className="h-8 w-auto" />
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
                onClick={() => {
                  setConversionData(null);
                  setActivePage('dashboard');
                }}
              >
                ← BACK TO NAVIGATION
              </button>
            </div>
          </div>
        </div>
        <div className="px-6 py-8">
          <JobsManagement
            conversionData={conversionData}
            onConversionComplete={() => setConversionData(null)}
          />
        </div>
      </div>
    );
  }

  if (activePage === 'invoicing') {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b">
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <img src="/jft-logo.png" alt="JFT Contracting" className="h-8 w-auto" />
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
                onClick={() => setActivePage('dashboard')}
              >
                ← BACK TO NAVIGATION
              </button>
            </div>
          </div>
        </div>
        <div className="px-6 py-8">
          <InvoiceManagement />
        </div>
      </div>
    );
  }

  if (activePage === 'reporting') {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b no-print">
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <img src="/jft-logo.png" alt="JFT Contracting" className="h-8 w-auto" />
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
                onClick={() => setActivePage('dashboard')}
              >
                ← BACK TO NAVIGATION
              </button>
            </div>
          </div>
        </div>
        <ReportsMenu />
      </div>
    );
  }

  if (activePage === 'properties') {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b">
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <img src="/jft-logo.png" alt="JFT Contracting" className="h-8 w-auto" />
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
                onClick={() => setActivePage('dashboard')}
              >
                ← BACK TO NAVIGATION
              </button>
            </div>
          </div>
        </div>
        <div className="px-6 py-8">
          <PropertiesManagement />
        </div>
      </div>
    );
  }

  if (activePage === 'preferences') {
    return (
      <div className="min-h-screen bg-gray-100">
        <div className="bg-white shadow-sm border-b">
          <div className="px-6 py-4">
            <div className="flex justify-between items-center">
              <img src="/jft-logo.png" alt="JFT Contracting" className="h-8 w-auto" />
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
                onClick={() => setActivePage('dashboard')}
              >
                ← BACK TO NAVIGATION
              </button>
            </div>
          </div>
        </div>
        <Preferences />
      </div>
    );
  }

  // Other module pages (placeholder)
  const currentTile = navTiles.find(tile => tile.id === activePage);
  const IconComponent = currentTile?.icon || User;

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="px-6 py-6">
          <div className="flex justify-between items-center">
            <div className="flex items-center space-x-4">
              <div className={`${currentTile?.color || 'bg-gray-500'} text-white p-3 rounded-lg`}>
                <IconComponent size={32} />
              </div>
              <h1 className="text-3xl font-bold text-gray-800">
                {activePage.toUpperCase()}
              </h1>
            </div>
            <button
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg"
              onClick={() => setActivePage('dashboard')}
            >
              ← BACK TO NAVIGATION
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-6 py-8">
        <div className="bg-white rounded-xl shadow-lg p-12">
          <div className="text-center">
            <div className={`${currentTile?.color || 'bg-gray-500'} text-white p-6 rounded-full w-24 h-24 mx-auto mb-6 flex items-center justify-center`}>
              <IconComponent size={48} />
            </div>
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              {activePage.charAt(0).toUpperCase() + activePage.slice(1)} Module
            </h2>
            <p className="text-gray-600 text-xl mb-8">
              Ready to build this module!
            </p>
            <div className="bg-green-50 border-l-4 border-green-400 p-6 rounded-lg">
              <div className="flex">
                <div className="ml-3">
                  <p className="text-green-700 font-medium">
                    Development Ready
                  </p>
                  <p className="text-green-600 mt-1">
                    This {activePage} module is ready to be implemented.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;